<template>
  <div id="app">
    <div class="main-header fixed-toolbar">
      <md-toolbar
        class="md-primary main-header fixed-toolbar md-dense"
        md-elevation="1"
        v-if="this.$session.exists()"
      >
        <md-button
          class="md-icon-button"
          @click.native="debeMostrarNav()"
        >
          <md-icon>menu</md-icon>
        </md-button>
        <h3
          class="md-title"
          style="flex: 1"
        >CFOSC Administración</h3>
        <md-button
          class="md-icon-button"
          href="http://administracion.fortalecimiento.org/manual.pdf"
          target="_blank"
        >
          <md-icon>help_outline</md-icon>
        </md-button>
      </md-toolbar>
    </div>
    <md-drawer
      :md-active.sync="mostrarNav"
      class="fixed-toolbar"
    >
      <md-toolbar
        class="md-transparent"
        md-elevation="0"
      >
        <img
          src="./assets/logo_landscape.png"
          style="padding:12px"
          alt="Menu, Logo CFOSC"
        />
      </md-toolbar>
      <md-list>
        <md-list-item
          @click="mostrarNav = false"
          to="/"
        >
          <md-icon>home</md-icon>
          <span class="md-list-item-text">Inicio</span>
        </md-list-item>
        <md-list-item md-expand>
          <md-icon>people_outline</md-icon>
          <span class="md-list-item-text">Empleados</span>
          <md-list slot="md-expand">
            <md-list-item
              class="md-inset"
              @click="mostrarNav = false"
              to="/empleados"
            >Empleados registrados</md-list-item>
            <md-list-item
              class="md-inset"
              @click="mostrarNav = false"
              to="/empleado/nuevo"
            >Registrar empleado</md-list-item>
          </md-list>
        </md-list-item>
        <md-list-item md-expand>
          <md-icon>assignment</md-icon>
          <span class="md-list-item-text">Publicaciones</span>
          <md-list slot="md-expand">
            <md-list-item
              class="md-inset"
              @click="mostrarNav = false"
              to="/publicaciones"
            >Publicaciones registradas</md-list-item>
            <md-list-item
              class="md-inset"
              @click="mostrarNav = false"
              to="/publicacion/nueva"
            >Crear publicación</md-list-item>
            <md-list-item
              class="md-inset"
              @click="mostrarNav = false"
              to="/categorias"
            >Categorías</md-list-item>
            <md-list-item
              class="md-inset"
              @click="mostrarNav = false"
              to="/publicaciones/reporte"
            >Reporte de visitas</md-list-item>
          </md-list>
        </md-list-item>
        <md-list-item
          @click="mostrarNav = false"
          to="/sitios"
        >
          <md-icon>language</md-icon>
          <span class="md-list-item-text">Sitios de interés</span>
        </md-list-item>
        <md-list-item md-expand>
          <md-icon>supervisor_account</md-icon>
          <span class="md-list-item-text">Suscripciones</span>
          <md-list slot="md-expand">
            <md-list-item
              class="md-inset"
              @click="mostrarNav = false"
              to="/suscripciones/precios"
            >Precio de suscripción</md-list-item>
            <md-list-item
              class="md-inset"
              @click="mostrarNav = false"
              to="/suscripciones/cuentas"
            >Usuarios registrados</md-list-item>
          </md-list>
        </md-list-item>
        <md-list-item @click="cerrarSesion()">
          <md-icon>exit_to_app</md-icon>
          <span class="md-list-item-text">Cerrar sesión</span>
        </md-list-item>
      </md-list>
    </md-drawer>
    <router-view
      class="main-content container"
      :sb="sb"
    />
    <md-snackbar
      :md-position="sb.position"
      :md-duration="sb.infinito ? Infinity : sb.duracion"
      :md-active.sync="sb.mostrar"
      md-persistent
    >
      <span>{{sb.texto}}</span>
    </md-snackbar>
  </div>
</template>
<script>
export default {
  methods: {
    debeMostrarNav() {
      this.mostrarNav = this.mostrarNav === true ? false : true;
    },
    cerrarNav() {
      this.mostrarNav = false;
    },
    cerrarSesion() {
      this.mostrarNav = false;
      this.$session.destroy();
      this.$router.push("/login");
    }
  },
  data() {
    return {
      mostrarNav: false,
      sb: {
        texto: "",
        mostrar: false,
        position: "center",
        infinito: false,
        duracion: 7000,
        isInfinity: false
      }
    };
  },
  created() {
    this.showSnackbar = this.mostrarSB;
    this.$material.locale.days = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ];
    this.$material.locale.shortDays = [
      "Dom",
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Sáb"
    ];
    this.$material.locale.shorterDays = ["D", "L", "M", "M", "J", "V", "S"];
    this.$material.locale.months = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ];
    this.$material.locale.shortMonths = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ];
    this.$material.locale.shorterMonths = [
      "E",
      "F",
      "M",
      "A",
      "M",
      "Jn",
      "Jl",
      "A",
      "S",
      "O",
      "N",
      "D"
    ];
  }
};
</script>
<style lang="scss">
@import "styles/main.css";
@import "~vue-material/dist/theme/engine";
@include md-register-theme(
  "default",
  (
    primary: #211915,
    accent: #f7eb29
  )
);
@include md-register-theme(
  "login",
  (
    primary: #211915,
    accent: #f7eb29
  )
);
@import "~vue-material/dist/theme/all";
</style>
<style>
</style>